import React, { useState, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./TalepFormu.css";

const TalepFormu = () => {
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const recaptchaRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;

    if (!recaptchaToken) {
      toast.error("Lütfen reCAPTCHA doğrulamasını yapın.");
      return;
    }

    const data = {
      adsoyad: form.adsoyad.value,
      email: form.email.value,
      telefon: form.telefon.value,
      roller: Array.from(form.querySelectorAll('[name="roller"]:checked')).map(
        (el) => el.parentNode.textContent.trim()
      ),
      onay1: form.onay1.checked ? "Evet" : "Hayır",
      onay2: form.onay2.checked ? "Evet" : "Hayır",
      recaptchaToken: recaptchaToken,
    };

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(data.email)) {
      toast.error("Geçerli bir e-posta adresi giriniz.");
      return;
    }

    try {
      const response = await fetch(process.env.REACT_APP_GOOGLE_SCRIPT_URL, {
        method: "POST",
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (result.result === "success") {
        toast.success("Talebiniz başarıyla alındı.");
        form.reset();
        setRecaptchaToken(null);
        recaptchaRef.current.reset();
      } else {
        toast.error("Gönderim sırasında bir hata oluştu.");
      }
    } catch (err) {
      console.error("Hata:", err);
      toast.error("Sunucu hatası oluştu.");
    }
  };

  return (
    <>
      <section id="talep-formu" className="talep-form-section">
        <div className="talep-form-container">
          <h2 className="form-title">
            Talep <span>Formu</span>
          </h2>
          <p className="form-subtitle">
            Form üzerinden iletişime geçebilirsiniz.
          </p>

          <form className="talep-form" onSubmit={handleSubmit}>
            <label>Ad Soyad</label>
            <input type="text" name="adsoyad" placeholder="Ad Soyad" required />

            <label>Email</label>
            <input type="email" name="email" placeholder="Email" required />

            <label>Telefon</label>
            <input type="tel" name="telefon" placeholder="Telefon" required />

            <div className="checkbox-group">
              <label>
                <input type="checkbox" name="roller" /> Afazi Hastasıyım
              </label>
              <label>
                <input type="checkbox" name="roller" /> Doktor
              </label>
              <label>
                <input type="checkbox" name="roller" /> Afazi Hastası Yakınıyım
              </label>
              <label>
                <input type="checkbox" name="roller" /> Dil ve Konuşma Terapisti
              </label>
            </div>

            <p className="form-subheading">Onaylanmalı</p>

            <label className="checkbox-full">
              <input type="checkbox" name="onay1" required />
              Aydınlatma metninde belirtilen ilkeler nezdinde Elektronik Ticaret
              iletisi almak istiyorum
            </label>

            <label className="checkbox-full">
              <input type="checkbox" name="onay2" required />
              Kişisel verilerin işlenmesine dair aydınlatma metnini okudum.
            </label>

            {/* reCAPTCHA eklentisi */}
            <div className="talep-form-recaptcha-container">
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                onChange={(token) => setRecaptchaToken(token)}
              />
            </div>
              <button type="submit" className="submit-button">
                BAŞVUR
              </button>
          </form>

        </div>
      </section>

      <ToastContainer position="bottom-center" autoClose={3000} />
    </>
  );
};

export default TalepFormu;
